import {Pipe, PipeTransform} from '@angular/core';
import {ItemModuleDto} from '../../Models/Module/module.interface';

@Pipe({
  name: 'modulesItems',
  standalone: false
})
export class ModulesItemsPipe implements PipeTransform {

  transform(items: ItemModuleDto[], filter: { favorite: boolean }): ItemModuleDto[] {

    if (!items.length) {
      return [];
    }

    return items.filter((item) => filter.favorite ? item.favorite : !item.favorite);

  }

}
